//重构 area
export function getarea(obj) {
  let newarray = [];
  obj.map((res, i) => {
    let name = res
    var children=''
    //console.log(res,'res')
    try{
      if(res.cityList.length>0){
        children={children: []}
      }
    }catch(e){}
    var label = {
      label: name['name']||name['EName'],
      value: name['name']||name['EName'],
      ...children
    }
    newarray.push(label);
    try{
      name['cityList'].map((item, j) => {
        var city = {
          label: item['name']||item['EName'],
          value: item['name']||item['EName'],
          children: []
        };
        newarray[i]["children"].push(city);
        item['areaList'].map((val,k)=>{
          var area={
              label: val,
              value: val,
          }
          newarray[i]["children"][j]["children"].push(area);
        })
  
      })
    }catch(e){}
  })
  return newarray
}



// WEBPACK FOOTER //
// ./src/api/area.js